import { render, staticRenderFns } from "./yian-detail2.vue?vue&type=template&id=fbe1a03a&scoped=true&"
import script from "./yian-detail2.vue?vue&type=script&lang=ts&"
export * from "./yian-detail2.vue?vue&type=script&lang=ts&"
import style0 from "./yian-detail2.vue?vue&type=style&index=0&id=fbe1a03a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe1a03a",
  null
  
)

export default component.exports